import React from 'react'
import classnames from 'classnames'
import Modal from './Modal'
import HTMLText from './HTMLText'
import Button from './Button'

import '../styles/alert.scss'

function Alert({ title, message, buttons = [] }) {
  return (
    <Modal>
      <div className="account-alert">
        <div className="account-alert__title">{title}</div>
        <div className="account-alert__message">
          <HTMLText html={message} />
        </div>
        <div className="account-alert__buttons">{buttons.map(ButtonItem)}</div>
      </div>
    </Modal>
  )
}

const ButtonItem = ({text, type, onClick = () => {}, component, href}, index) => {
  return (
    <div className="account-alert__button-item" key={index}>
      {component ? (
        <>
          <Button
            className={classnames('account-alert__button', { 'account-button--dusty-gray': type === 'cancel' })}
            component={component ? component : ''}
            href={href}
            target="_blank">
            {text}
          </Button>
        </>
      ) : (
        <Button
          className={classnames('account-alert__button', { 'account-button--dusty-gray': type === 'cancel' })}
          onClick={onClick}>
          {text}
        </Button>
      )}
    </div>
  )
}

export default Alert
